import utils from '../../../common/utils'
import api from '../../../common/api'

export default {
    methods: {
        changePage(val) {
            this.curPage = val
            this.initData()
        },
        changePageSize(val) {
            this.pageSize = val
            this.initData()
        },
        resetPwd(row) {
            api.resetPwd({
                id: row.id
            }).then((res) => {
                if (res.resultCode === 0) {
                    this.$Message.success({
                        content: '密码重置成功!'
                    })
                } else {
                    this.$Message.error(res.resultMessage)
                }
            })
        },
        handleChoiceColumn(selection, type) {
            if (selection.length < 1) { return }
            switch (type) {
            case 'one':
                this.curChoiceUser.push(selection[0].id)
                break;
            case 'all':
                this.curChoiceUser = selection.map((item) => item.id)
                break;
            default:
                break;
            }
        },
        handleCancelChoice(selection, type, row) {
            switch (type) {
            case 'one':
                this.curChoiceUser.splice(this.curChoiceUser.indexOf(row.id), 1)
                break;
            case 'all':
                this.curChoiceUser = []
                break;
            default:
                break;
            }
        },
        handleBatchDel(data) {
            this.curOperator = data.id ? 'one' : 'batch'
            this.curOperatorId = data.id
            if (!data.id && this.curChoiceUser.length < 1) {
                this.$Message.error({
                    background: true,
                    content: '请选择需要删除的行'
                })
                return
            }
            this.removeDialogObj.isShow = true
        },
        updateUserInfo(row) {
            console.log(row)
            api.getUserInfo(row.id).then((res) => utils.resSucFactory(res, () => {
                this.changeObj('e', res.data)
            }, (err) => {
                console.log(err)
                this.$Message.error({
                    background: true,
                    content: err.resultMessage
                })
            }))
        },
        handleCloseDelDialog(type) {
            this.removeDialogObj.isShow = false
            if (!type) { return }
            if (this.curOperator === 'batch') { this.batchRemoveUser(this.curChoiceUser) }
            if (this.curOperator === 'one') { this.batchRemoveUser([this.curOperatorId]) }
        },
        async openUserAttrDialog() {
            await this.getUserAttrList()
            this.userAttrObj.isShow = true
        },
        handleCloseAttrDialog() {
            this.getDisplayField()
            this.getUserAttrList()
            this.userAttrObj.isShow = false
        },
        searchResult() {
            this.curPage = 1
            this.initData('search')
            if (!this.isShowSearchResult) {
                this.isShowSearchResult = true
            }
            this.getDisplayField()
        },
        backHistory() {
            this.curSearchTxt = this.curSearchField === 'sex' ? '-1' : ''
            this.curPage = 1
            this.initData()
            this.isShowSearchResult = false
            this.getDisplayField()
        }
    }
}
